import { Grid } from '../../../imports/muiImport';
import { useState, useSelector } from '../../../imports/generalImport';
import UserDetailPayment from './paymentUtils/UserDetailPayment';
import UserPayButton from './paymentUtils/UserPayButton';
import { useAuth } from '../../../hooks/contexts/AuthContext';
import PaymentOrderReceipt from './paymentUtils/PaymentOrderReceipt';
import PayFromWallet from './paymentUtils/PayFromWallet';
// import ReferGiftCard from '../../../components/referGiftCard/ReferGiftCard';

function Payment() {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const [walletPayment, setWalletPayment] = useState({
    paymentMethod: null,
    isWalletPayment: false,
  });
  const { isLoggedIn } = useAuth();

  return (
    <Grid
      container
      maxWidth="false"
      sx={{
        py: { xs: 1, sm: 3, lg: 2 },
        px: { xs: 2, sm: 2, lg: 2 },
        minWidth: '100%',
        alignContent: {
          lg: 'flex-start',
        },
        border: 1,
        borderRadius: {
          xs: 2,
          lg: 3,
        },
        borderColor: 'lightSecondary.main',
        boxShadow: { xs: 0, sm: 5, lg: 1 },
      }}
    >
      <Grid item xs={12} lg={isLoggedIn ? 6 : 12} xl={isLoggedIn ? 6 : 12} sx={{ pr: { lg: 1 } }}>
        <PaymentOrderReceipt isWalletAccepted={walletPayment.isWalletPayment} />
      </Grid>

      {isLoggedIn && (
        <>
          <Grid item xs={12} lg={isLoggedIn ? 6 : 12} xl={isLoggedIn ? 6 : 12}>
            <UserDetailPayment />
          </Grid>

          <Grid item xs={12}>
            <PayFromWallet walletPayment={walletPayment} setWalletPayment={setWalletPayment} />

            {/* {PRODUCTDETAILS?.isShowGiftDesignOption && <ReferGiftCard />} */}
          </Grid>
        </>
      )}

      {/* User Pay Button */}
      <Grid
        item
        xs={12}
        sx={{
          position: { xs: 'sticky', lg: 'relative' },
          bottom: 0,
          zIndex: 0,
        }}
      >
        <UserPayButton
          isLoggedIn={isLoggedIn}
          walletPayment={walletPayment}
        />
      </Grid>
    </Grid>
  );
}

export default Payment;
